uniform float time;
uniform vec3 cameraPos;

attribute vec3 offset;
attribute float scale;
attribute mat3 instanceRotationMatrix;

varying float vHeight;

const float WIND_CUTOFF_DISTANCE_SQ = 350.0 * 350.0;

// Simplified hash function using fewer operations
float hash(vec2 p) {
    return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);
}

// Simplified noise - single sample instead of bilinear interpolation
float fastNoise(vec2 p) {
    vec2 i = floor(p);
    vec2 f = fract(p);
    // Use smoother step function
    vec2 u = f * f * f * (f * (f * 6.0 - 15.0) + 10.0);
    
    return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x),
               mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y);
}

void main() {
    // Transform grass geometry
    vec3 transformedGrass = position * scale;
    transformedGrass = instanceRotationMatrix * transformedGrass;
    transformedGrass += offset;
    
    // Pre-calculate commonly used values
    vHeight = clamp(position.y, 0.0, 1.0);
    
    // Skip wind calculations if beyond cutoff distance (squared to avoid sqrt)
    float dx = transformedGrass.x - cameraPos.x;
    float dz = transformedGrass.z - cameraPos.z;
    float distSq = dx * dx + dz * dz;

    if (distSq <= WIND_CUTOFF_DISTANCE_SQ) {
        vec2 worldPos = transformedGrass.xz;
        
        // Single noise calculation for both axes (reuse result)
        float baseNoise = fastNoise(worldPos * 0.1);
        float timeNoise = fastNoise(vec2(time * 0.1, time * 0.05));
        
        // Combine noise effects
        float windVariation = timeNoise * 0.35;
        float totalWindEffect = 0.13 + windVariation;
        
        // Pre-calculate sine wave components
        float timeOffset = time * 2.0;
        float noiseOffset = baseNoise;
        
        // Calculate displacement power once
        float displacementPower = 1.0 - cos(vHeight * 7.854); // 3.1416 / 0.4 = 7.854
        
        // Apply wind displacement to both axes
        float sinZ = sin(offset.z * noiseOffset + timeOffset);
        float sinX = sin(offset.x * noiseOffset + timeOffset);
        
        transformedGrass.z += sinZ * totalWindEffect * displacementPower;
        transformedGrass.x += sinX * totalWindEffect * displacementPower * 1.2; 
    }
    
    csm_Position = transformedGrass;
}



